import styled from "styled-components";



export const SignatureMainDiv = styled.div`
    background-color: #1e1e1e;
    color: #dcffdf;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 10vh;
    max-width: 100vw;
    scroll-snap-align: start;
    font-family: 'Montserrat'
`